import facepaint from "facepaint";

export default facepaint(["@media(min-width: 768px)"]);
